import Vue from 'vue';
import Vuex from 'vuex';
import pub from './public';
import system from './system';
import home from './home';
Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        pub,
        system,
        home
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js